import PropTypes from "prop-types";
import RadioList from "../Inputs/RadioList";

function RadioStep({
  title,
  description,
  perRow,
  options,
  statekey,
}: {
  title: string;
  description: string;
  perRow: number;
  options: Array<{ label: string; value: string }>;
  statekey: string;
}) {
  return (
    <div className="Step RadioStep">
      <h2>{title}</h2>
      <p>{description}</p>
      <RadioList options={options} perRow={perRow} statekey={statekey} />
    </div>
  );
}

export default RadioStep;

RadioStep.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  perRow: PropTypes.number,
  statekey: PropTypes.string,
};
